import { FC } from "react";
import { Button, Flex, FlexProps, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import { WarningIcon } from "@shared/components/Icons";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";
import { selectors } from "@containers/Cases/store";
import { MEDICAL_FIELD_LABELS, MEDICAL_FIELDS_FORM_ORDER } from "@containers/Cases/constants";
import { useCaseDocumentActions } from "@containers/Cases/hooks";
import { joinWithAnd } from "@containers/Cases/utils/caseDocuments";

const CaseFieldChoicesBanner: FC<FlexProps> = (props) => {
  const caseObj = useSelector(selectors.getCase());
  const { chooseValues } = useCaseDocumentActions(caseObj?.id);

  const fieldNames = MEDICAL_FIELDS_FORM_ORDER.filter((field) =>
    caseObj?.pending_choices?.some((choice) => choice.field === field),
  ).map((field) => MEDICAL_FIELD_LABELS[field]);

  if (!fieldNames.length) return null;

  return (
    <Flex
      wrap="wrap"
      align="center"
      justify="space-between"
      gap={3}
      px="18px"
      py="14px"
      borderRadius="10px"
      border="1px solid"
      borderColor="score.midText/30"
      bg="score.midBg"
      {...props}
    >
      <Flex align="center" gap="10px" color="brand.warningText">
        <WarningIcon boxSize="18px" flexShrink={0} color="score.midText" />
        <Text fontSize="14px" lineHeight={1.5}>
          <Text as="span" fontWeight={FONT_WEIGHT.BOLD}>
            {joinWithAnd(fieldNames)}
          </Text>{" "}
          {fieldNames.length > 1 ? "have" : "has"} values from both the PSR and the medical summaries. Choose which to
          keep.
        </Text>
      </Flex>
      {chooseValues && (
        <Button variant="primary" size="sm" fontSize="14px" onClick={() => chooseValues()}>
          Choose values
        </Button>
      )}
    </Flex>
  );
};

export default CaseFieldChoicesBanner;
